// Copied from whatsapp-console-frontend `src/pages/AdTemplates/designTokens.js`
// and its theme, so the public Ads Agent prompt box matches the console one
// pixel for pixel. Use these only inside the AdsGeneratorPage.
export const AD = {
  primary: '#0a474c',
  primarySoft: '#ebf5f3',
  cta: '#42B864',
  accent: '#fec000',

  text: '#4A4A4A',
  textMuted: '#6E6E6E',
  textHint: '#B9B9B9',
  onPrimary: '#fff',

  surface: '#fff',
  surfaceSubtle: '#fafafa',
  surfaceSunken: '#f5f5f5',
  border: '#e0e0e0',
  borderSubtle: '#f0f0f0',
  divider: 'rgba(0, 0, 0, 0.12)',

  error: '#f44336',

  decorAccent: '#fec000',
  decorSoft: '#7BA8A3',
  decorTint: '#A9C9C4',

  radius: 6,
  radiusLg: 8,
  radiusPill: 999,

  shadowNone: 'none',
  shadowCard: '0 1px 3px rgba(0,0,0,0.06)',

  controlHeight: 36,

  fontFamily:
    '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
};

export default AD;
